var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('transition',{attrs:{"name":"fade"}},[_c('g',[_c('g',{attrs:{"transform":"translate(670, -490)"}},[_c('logoutButton')],1),(
                    _vm.done_rspan != 0 && _vm.done_spatial != 0 && _vm.done_digits != 0
                )?_c('g',[_c('text',{staticClass:"txt",attrs:{"x":"0","y":"-10","text-anchor":"middle","dominant-baseline":"middle","font-family":"sans-serif","font-size":"50","fill":"#000000"}},[_vm._v(_vm._s("Tack! Nu är alla uppgifter klara."))])]):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }